import React from 'react';
import { FieldPath, FieldValues } from 'react-hook-form';
import { VehicleMakeSelect } from '../inputs/vehicle-make-select';
import { OptionOrOptions } from '../option';
import { CommonControlProps, IntegratedFormControl } from './integrated-form-control';

type VehicleMakeSelectProps = React.ComponentProps<typeof VehicleMakeSelect>;
type Props<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> = CommonControlProps<TFieldValues, TName> & {
    vehicleMakeSelectProps?: VehicleMakeSelectProps;
    cRef?: React.Ref<HTMLInputElement>; // 	https://fettblog.eu/typescript-react-generic-forward-refs/
};

export function FormVehicleMakeSelect<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>(props: Props<TFieldValues, TName>): React.ReactElement {
    const { vehicleMakeSelectProps, ...integratedFormControlProps } = props;
    const renderViewMode = React.useCallback((value: OptionOrOptions) => {
        if (Array.isArray(value)) {
            if (value.length === 0) return '--';
            return value.map((option) => option.label).join(', ');
        }
        return value.label;
    }, []);
    return (
        <IntegratedFormControl {...integratedFormControlProps} renderViewMode={renderViewMode}>
            {(inputProps) => <VehicleMakeSelect {...inputProps} {...vehicleMakeSelectProps} />}
        </IntegratedFormControl>
    );
}
